import React, { useState, useContext, useMemo, useEffect } from 'react'
import { AuthContext } from '../../../../Api/firebase'
import { AllStarContext } from '../../../../Context'
import { validateEmail } from '../../../../Components/Auth/authHelpers'
import { SaveBar } from '../../styles'
import { BlueBtn } from '../../../../Components/Buttons/styles'
import { useVoteStatus, useEmail } from './hooks'
import { EmailInput } from './styles'

export const SaveCon: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { login, isLoggedIn, authLoading } = useContext(AuthContext)!
  const { saveAllPicks } = useContext(AllStarContext)!
  const { email, setEmail } = useEmail()
  const { canVote, setCanVote } = useVoteStatus()

  const [isSaving, setSaving] = useState<boolean>(false)
  const [errorMsg, setErrorMsg] = useState<string>('')
  const [success, setSuccess] = useState<boolean>(false)

  useEffect(() => {
    if (authLoading) return
  }, [isLoggedIn, authLoading])

  const handleEmailChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setEmail(event.target.value)
  }

  const isButtonActive = useMemo(
    () => email.includes('@') && !isSaving && canVote,
    [email, isSaving, canVote, isLoggedIn, authLoading]
  )

  const buttonText = useMemo(() => {
    if (success) return 'Success!'
    if (isSaving) return 'Saving...'
    if (!canVote) return 'Locked'
    return 'Submit Vote'
  }, [success, isSaving, canVote])

  const handleSave = async () => {
    if (!isButtonActive) return

    const { errorMsg: validationError } = validateEmail(email)
    if (validationError) {
      setErrorMsg(validationError)
      return
    }

    setErrorMsg('')
    setSaving(true)

    try {
      const res = await saveAllPicks(email)
      if (res) {
        setSuccess(true)
        setCanVote(false)
        setTimeout(() => {
          setSuccess(false)
        }, 3000)
      }
    } catch (e) {
      setErrorMsg('An unexpected error occurred.')
    } finally {
      setSaving(false)
    }
  }

  if (authLoading && !isLoggedIn)
    return (
      <SaveBar addMargin={isLoggedIn}>
        <div className="submitCon">
          <div className="subtextCon">
            <div className="subtext">Loading login status...</div>
          </div>
        </div>
      </SaveBar>
    )

  return (
    <SaveBar addMargin={isLoggedIn}>
      <div className="submitCon">
        <EmailInput
          required
          aria-label="email input"
          inputMode="email"
          label="Email"
          variant="outlined"
          margin="none"
          id="email"
          size="small"
          value={email}
          onChange={handleEmailChange}
        />
        <div className="error">{errorMsg}</div>
        <BlueBtn onClick={handleSave} disabled={!isButtonActive}>
          {buttonText}
        </BlueBtn>
      </div>
      {!isLoggedIn && (
        <div className="subtextCon">
          <div className="subtext">{`-- Or `}</div>
          <button className="loginBtn" onClick={() => login()}>
            login
          </button>
          <div className="subtext">to get PLL Nation credit. --</div>
        </div>
      )}
    </SaveBar>
  )
}
